import classNames from "classnames";
import { useTranslations } from "next-intl";

import styles from "./review-stars.module.scss";

type PropsProductReviews = {
  rating: number;
  id: number | string;
  inQuarters?: boolean;
  context?: "snippet" | "list";
};

export default function ReviewStars(props: PropsProductReviews) {
  const t = useTranslations();
  const { rating, id, inQuarters, context } = props;
  const starFillingClass = (rating: number, index: number, inQuarters?: boolean) => {
    const fill = Math.max(0, Math.min(1, rating - (index - 1)));
    if (inQuarters) {
      const quarterValue = Math.floor(fill * 4) * 25;
      return quarterValue.toString();
    } else {
      return (Math.floor(fill) * 100).toString();
    }
  };
  const modifierClass = context === "snippet" ? "small" : context === "list" ? "medium" : "";

  return (
    <div className={styles.reviewsStars} role="img" aria-label={t("a11y.ratings_average", { average: rating, max: 5 })}>
      {Array.from({ length: 5 }).map((v, i) => (
        <span
          className={classNames(
            styles.reviewsStar,
            styles[`star-${starFillingClass(rating, i + 1, inQuarters)}-filled`],
            styles[modifierClass]
          )}
          key={`${i}-${id}`}
        ></span>
      ))}
    </div>
  );
}
